var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[_c('div',{staticClass:"title"},[(_vm.title)?_c('div',{staticClass:"default"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.$slots.title)?_vm._t("title"):_vm._e()],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }